<template>
    <div class="home">
        <div class="menus row-center">
            <div class="menu-left">
                <menu-button @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/park.png'),
                        require('../assets/img/park_c.png'),
                    ]" content="园区总览" @onSelected="parkOverview">
                </menu-button>
            </div>
            <div class="menu-right row-center">
                <menu-button @click="menu === 2 ? menu = -1 : menu = 2" :selected="menu === 2" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/property.png'),
                        require('../assets/img/property_c.png'),
                    ]" content="设备分布" @onSelected="propertyOverview" @onUnselected="clearPropertyOverview">
                </menu-button>
                <menu-button v-if="hasMonitor()" @click="menu === 3 ? menu = -1 : menu = 3" :selected="menu === 3" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/safety.png'),
                        require('../assets/img/safety_c.png'),
                    ]" content="安防监控" @onSelected="siteSafety" @onUnselected="clearSiteSafety"></menu-button>
                <menu-button @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/electric.png'),
                        require('../assets/img/electric_c.png'),
                    ]" content="电力桥架" @onSelected="siteElectric" @onUnselected="clearSiteElectric">
                </menu-button>
            </div>
        </div>

        <ChangeSite :areaId="$route.params.id" />
        <SiteOverView :areaId="$route.params.id" />
        <ElectricChart :paramType="'AREA_ID'" :areaId="$route.params.id" />
        <SiteOperationData :areaId="$route.params.id" />
        <Surveillance :areaId="$route.params.id" :iframeWin="iframeWin" />
        <Distribution :areaId="$route.params.id" />


        <iframe name="THREE" frameborder="0" width="100%" height="100%" ref="iframeThree"
            :src=" url + $store.getters.getThreeUrl(areaId) + '.html'">
        </iframe>
    </div>
</template>

<script>
    import ChangeSite from "./contentBlock/ChangeSite"
    import SiteOverView from './contentBlock/SiteOverView';
    import ElectricChart from './contentBlock/ElectricChart';
    import SiteOperationData from './contentBlock/SiteOperationData';
    import Surveillance from './contentBlock/Surveillance';
    import Distribution from './contentBlock/Distribution';
    import MenuButton from "../components/MenuButton";
    import {
        config
    } from '../config'

    export default {
        name: "Site",
        components: {
            ChangeSite,
            SiteOverView,
            ElectricChart,
            SiteOperationData,
            Surveillance,
            Distribution,
            MenuButton,
        },
        data() {
            return {
                // 用于底部菜单导航
                menu: 0,
                url: config.threeUrl,
                iframeWin: {},
            };
        },
        created() {
            this.areaId = this.$route.params.id
        },
        mounted() {
            this.iframeWin = this.$refs.iframeThree.contentWindow;
            window.addEventListener("message", this.handleMessage);
        },
        methods: {
            hasMonitor() {
                let details = this.$store.state.surveillance.find(item => item.areaId == this.areaId).rooms.details[0]
                if (details.length > 0) {
                    return true
                } else {
                    return false
                }
            },
            postMonitorMessage(index) {
                this.currentDetails = index;
                this.iframeWin.postMessage({
                        cmd: this.currentDetails == 0 ? "KJMain" : "KJSub",
                    },
                    "*"
                );
            },
            parkOverview() {
                this.$router.push({
                    path: "/"
                });
            },
            clearparkOverview() {},
            propertyOverview() {
                this.iframeWin.postMessage({
                        cmd: "propertyOverview",
                    },
                    "*"
                );
            },
            clearPropertyOverview() {
                this.iframeWin.postMessage({
                        cmd: "clearPropertyOverview",
                    },
                    "*"
                );
            },
            siteSafety() {
                this.iframeWin.postMessage({
                        cmd: "siteSafety",
                    },
                    "*"
                );
            },
            clearSiteSafety() {
                this.iframeWin.postMessage({
                        cmd: "clearSiteSafety",
                    },
                    "*"
                );
            },
            siteElectric() {
                this.iframeWin.postMessage({
                        cmd: "siteElectric",
                    },
                    "*"
                );
            },
            clearSiteElectric() {
                this.iframeWin.postMessage({
                        cmd: "clearSiteElectric",
                    },
                    "*"
                );
            },
            handleMessage(event) {
                //console.log(event);
                // 根据上面制定的结构来解析iframe内部发回来的数据
                const data = event.data;
                switch (data.cmd) {
                    case "returnData":
                        // 业务逻辑
                        console.log("得到html数据:" + data.params.data);
                        break;
                }
            },
        },
    };
</script>


<style lang="less" scoped>
    .menus {
        .w(1015);
        position: fixed;
        .wh(449, 54);
        left: @w;
        bottom: @h;
        justify-content: space-between;

        .menu-left {
            width: 160 / 1015 * 100%;
        }

        .menu-right {
            width: (1 - 160 / 1015) * 100%;
            justify-content: flex-end;

            .btn {
                .wh(16, 0);
                margin-left: @w;
            }
        }
    }

    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }
</style>